// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"31d6cfe0","138":"31d6cfe0","567":"31d6cfe0","613":"31d6cfe0"}[chunkId] + ".chunk.css";
};